import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { QualityDisputeRequest, QualityDisputeResponse } from '../../../../shared/issuesV2';

type CreateQualityDisputeVariables = {
  issueId: number;
  reason: QualityDisputeRequest['reason'];
  comment: string;
};

function createQualityDispute(
  { issueId, reason, comment }: CreateQualityDisputeVariables,
): Promise<Response & { data?: QualityDisputeResponse }> {
  return post<QualityDisputeRequest, QualityDisputeResponse>(`/api/v2/issues/${issueId}/disputes`, { reason, comment });
}

/** Hook for creating a quality issue dispute via the issues V2 disputes endpoint. */
export function useCreateQualityDispute() {
  return useToastedMutation({
    mutationFn: createQualityDispute,
    successToastMessage: 'Quality dispute submitted successfully.',
    errorToastMessage: 'Failed to submit quality dispute.',
  });
}
